import {
  IconNameEnum,
  useModuleBEM,
  useUiStyles,
} from "@b2bportal/core-themes";
import { CoreUiComponents } from "@b2bportal/core-types";
import type { NotificationBannerComponentProps } from "@b2bportal/core-ui";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Icon } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./NotificationBanner.module.scss";

const COMPONENT_KEY = CoreUiComponents.NotificationBanner;

export interface NotificationBannerProps
  extends NotificationBannerComponentProps {
  status?: "error" | "success" | "warning" | "info";
}

const statusIconMap = {
  error: IconNameEnum.warning,
  success: IconNameEnum.checkFilled,
  warning: IconNameEnum.warning,
  info: IconNameEnum.ui__infoPopover,
  default: undefined,
};

export const NotificationBanner = ({
  action,
  title,
  subtitle,
  className,
  status = "info",
  onClose,
}: NotificationBannerProps) => {
  const { t } = useI18nContext();
  const styles = useUiStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY, [status]);

  const iconName = status ? statusIconMap[status] : undefined;

  return (
    <div className={clsx(block, className)}>
      {iconName && <Icon className={cn("banner-icon")} iconName={iconName} />}
      <div className={cn("content")}>
        <div className={cn("title")}>{title}</div>
        {subtitle ? <div className={cn("subtitle")}>{subtitle}</div> : null}
        {action ? <div className={cn("action")}>{action}</div> : null}
      </div>
      {onClose ? (
        <button
          className={cn("close-button")}
          onClick={onClose}
          aria-label={t("close.button")}
        >
          <Icon iconName={IconNameEnum.close} />
        </button>
      ) : null}
    </div>
  );
};
